
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {},
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'GRUPO_EMAIL_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'GRUPO_EMAIL_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'GRUPO_EMAIL_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'GRUPO_EMAIL_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					id: item.id,
					valor: item.nome,
					emails: item.emails
				}))
			};

        default:
            return state;
    }
}
